import { html } from '@design.estate/dees-element';
import { demoApp } from '../../../demos/templates.js';
import { createKanbanDemo, kanbanDemoColumns, kanbanDemoPeople } from '../kanban.demodata.js';

export const demoFunc = () => {
  const demo = createKanbanDemo();
  return demoApp(html`<dees-kanban
    heading="Product workspace"
    .tickets=${demo.tickets}
    .columns=${kanbanDemoColumns}
    .people=${kanbanDemoPeople}
    .provider=${demo.provider}
  ></dees-kanban>`);
};
